export enum TelnyxErrorCode {
  InactivePhoneNumber = "10001",
  InvalidPhoneNumber = "10002",
  InvalidURL = "10003",
  MissingRequiredParameter = "10004",
  ResourceNotFound = "10005",
  InvalidID = "10006",
  UnexpectedError = "10007",
  RequestTimeout = "10008",
  AuthenticationFailed = "10009",
  AuthorizationFailed = "10010",
  TooManyRequests = "10011",
  DuplicateResource = "10012",
  MissingAssociation = "10013",
  UnsupportedMediaType = "10014",
  BadRequest = "10015",
  PhoneNumberMustBeInE164Format = "10016",
  AssociatedResourceDoesNotExist = "10017",
  InvalidSortDirection = "10018",
  InvalidEmailAddress = "10019",
  InvalidResourceType = "10020",
  ResourceInUse = "10021",
  OneOrMoreInvalidIDs = "10022",
  InvalidJSON = "10023",
  UnsupportedContentType = "10024",
  StringLengthOutOfRange = "10025",
  InvalidParameterType = "10026",
  UnprocessableEntity = "10027",
  CharacterEncodingError = "10028",
  ExpectedJSONContentType = "10029",
  MethodNotAllowed = "10030",
  InvalidRequestFilter = "10031",
  InvalidEnumeratedValue = "10032",
  ValueOutsideOfRange = "10033",
  ExpectedURLEncodedFormContentType = "10034",
  ResourceLocked = "10035",
  ResourceIsBeingProcessed = "10036",
  ServiceUnavailable = "10037",
  InvalidCallerData = "10700",
  InvalidResourceGroups = "20000",
  InvalidAPIKeySecret = "20001",
  APIKeyRevoked = "20002",
  APIKeyForbidden = "20003",
  InvalidPermissionGroups = "20004",
  InvalidUser = "20005",
  ExpiredAccessToken = "20006",
  InvalidPermissionGroupsSubset = "20007",
  InvalidAPIKey = "20008",
  InvalidUserDoesNotExist = "20009",
  InvalidInvitation = "20010",
  APIKeyInUse = "20011",
  AccountInactive = "20012",
  AccountBlocked = "20013",
  AccountUnverified = "20014",
  FeatureNotEnabled = "20015",
  AccountNotLevel1Verified = "20016",
  AccountNotLevel2Verified = "20017",
  InsufficientFunds = "20100",
  InvalidAddress = "20200",
  InvalidCountryCode = "20201",
  InvalidLocality = "20202",
  InvalidNeighborhood = "20203",
  InvalidAdministrativeArea = "20204",
  InvalidPostalCode = "20205",
  InvalidBorough = "20206",
  InvalidStreetAddress = "20207",
  InvalidStreetAddressHouseNumber = "20208",
  InvalidExtendedAddress = "20209",
  NotRoutable = "40001",
  BlockedAsSpamTemporary = "40002",
  BlockedAsSpamPermanent = "40003",
  RejectedByDestination = "40004",
  MessageExpiredDuringTransmission = "40005",
  RecipientServerUnavailable = "40006",
  LoopDetected = "40007",
  Undeliverable = "40008",
  InvalidMessageBody = "40009",
  Unregistered10DLCMessage = "40010",
  TooManyRequestsUpstream = "40011",
  InvalidMessagingDestinationNumber = "40012",
  InvalidMessagingSourceNumber = "40013",
  MessageExpiredInQueue = "40014",
  BlockedAsSpamInternal = "40015",
  TMobile10DLCSendingLimitReached = "40016",
  ATT10DLCSpamMessageRejected = "40017",
  ATT10DLCSendingLimitReached = "40018",
  ATT10DLCInvalidTagData = "40019",
  NumberNotMessagingEnabled = "40100",
  TollFreeNumberNotInRegistry = "40150",
  MessageEnablementPendingWithOtherProvider = "40151",
  InvalidOSRParameter = "40152",
  CannotAccessOSR = "40153",
  UnauthorizedNNID = "40154",
  LOARequired = "40155",
  UnauthorizedPropertyNameValue = "40156",
  TemporarilyBlocked = "40157",
  DeleteFailed = "40158",
  UnknownOSRError = "40159",
  BlockedDueToSTOPMessage = "40300",
  UnsupportedMessageTypeForToAddress = "40301",
  MessageTooLarge = "40302",
  MessageNotFound = "40303",
  InvalidCombinationOfMessageContentArguments = "40304",
  InvalidFromAddress = "40305",
  AlphaSenderNotConfigured = "40306",
  AlphaSenderMismatch = "40307",
  InvalidFromAddressForMMS = "40308",
  InvalidDestinationRegion = "40309",
  InvalidToAddress = "40310",
  InvalidMessagingProfileSecret = "40311",
  MessagingProfileIsDisabled = "40312",
  MissingMessagingProfileSecret = "40313",
  MessagingDisabledOnAccount = "40314",
  UnhealthyFromAddress = "40315",
  NoContentProvidedForMessage = "40316",
  InvalidMMSContent = "40317",
  MessageQueueFull = "40318",
  IncompatibleMessageTypeForToAddress = "40319",
  TemporarilyUnusableFromAddress = "40320",
  NoUsableNumbersOnMessagingProfile = "40321",
  BlockedDueToContent = "40322",
  MessagingActivationFailed = "40323",
  MessagingProductTypeChangeFailed = "40324",
  InvalidAlphanumericSenderID = "40325",
  CannotAssignAlphanumericSenderID = "40326",
  InvalidDomain = "40327",
  SMSExceedsRecommendedSize = "40328",
  TollfreeNumberNotVerified = "40329",
  TollfreeNumberNotProvisioned = "40330",
  MissingWhitelistedDestinations = "40331",
  BrandCannotBeDeleted = "40332",
  MessagingProfileSpendLimitReached = "40333",
  WhatsAppError = "41000",
  VRFStillDeployed = "50000",
  VRFNotDeployed = "50001",
  VRFAlreadyDeployed = "50002",
  InvalidIPAddress = "50003",
  PrivateIPAddressNotPermitted = "50004",
  InvalidCIDRBlock = "50005",
  PrivateCIDRBlockNotPermitted = "50006",
  CIDRBlockTooLarge = "50007",
  CannotDeleteIPFromSource = "50008",
  InvalidRoomID = "65001",
  ConsumptionReachedDataLimit = "70000",
  NotEnoughAvailableSIMCards = "70001",
  InvalidDataFormat = "70002",
  MobileOperatorsPreferencesOutOfSequence = "70003",
  OTAUpdateInProgress = "70004",
  CouldNotDeleteSIMCardGroup = "70005",
  CouldNotDeleteDefaultSIMCardGroup = "70006",
  SIMCardDoesNotHaveSIMCardGroup = "70007",
  PublicIPsUnavailable = "70008",
  WebhookDeliveryError = "75000",
  CouldNotResolveName = "75001",
  CouldNotConnectToHost = "75002",
  CertificateMisconfiguration = "75003",
  ExpiredCertificate = "75004",
  CertificateNameMismatch = "75005",
  UntrustedCertificateRoot = "75006",
  WebhookHostReturnedNon200HTTP2XX = "75299",
  WebhookHostReturnedHTTP3XX = "75300",
  WebhookHostReturnedHTTP400 = "75400",
  WebhookHostReturnedHTTP404 = "75404",
  WebhookHostReturnedHTTP4XX = "75499",
  WebhookHostReturnedHTTP500 = "75500",
  WebhookHostReturnedHTTP5XX = "75599",
  WrongAccount = "80000",
  InactiveNumber = "80001",
  WrongProvider = "80002",
  PendingOrder = "80003",
  InvalidDesiredDueDate = "80004",
  InvalidPasscodeOrPin = "80005",
  InvalidPON = "80006",
  FOCExpired = "80007",
  MissingLOA = "80008",
  IllegibleLOA = "80009",
  ExpiredLOA = "80010",
  InvalidSPID = "80011",
  UnsupportedCarrier = "80012",
  InvalidCountry = "80013",
  ServiceAddressMismatch = "80014",
  StrandedPhoneNumbers = "80015",
  NoCSRDataAvailable = "80016",
  InvalidServiceProviderType = "80017",
  InvalidFOCDate = "80018",
  InvalidServiceProviderID = "80019",
  InvalidSubscriptionStatus = "80020",
  InvalidPortingOption = "80021",
  InvalidDocumentType = "80022",
  InvalidValueForRateCenters = "80023",
  RecordCouldNotBeDeleted = "80024",
  SubscriptionVersionNotCreated = "80100",
  SubscriptionVersionDoesNotMatch = "80101",
  DuplicatePhoneNumbersFound = "80200",
  PhoneNumberLimitExceeded = "80201",
  InvalidCredentials = "80400",
  TooManyPhoneNumbers = "80401",
  MustSearchPhoneNumberViaSearchAPIFirst = "85000",
  PhoneNumbersNotAvailable = "85001",
  PhoneNumbersUpdateNotAllowedOnThisOrder = "85002",
  RegulatoryRequirementsAlreadySatisfied = "85003",
  InvalidConnectionIDProvided = "85004",
  InvalidMessagingProfileIDProvided = "85005",
  PhoneNumberAlreadyReserved = "85006",
  ReservationLimitExceeded = "85007",
  ReservationExtensionLimitExceeded = "85008",
  InvalidValueForFormat = "90000",
  InvalidValueForChannels = "90001",
  InvalidValueForTimeout = "90002",
  InvalidValueForInterDigitTimeout = "90003",
  InvalidValueForMin = "90004",
  InvalidValueForMax = "90005",
  InvalidValueForTries = "90006",
  InvalidValueForTerminatingDigit = "90007",
  InvalidValueForValidDigits = "90008",
  InvalidValueForLoop = "90009",
  InvalidValueForPayload = "90010",
  InvalidValueForPayloadType = "90011",
  InvalidValueForVoice = "90012",
  InvalidValueForLanguage = "90013",
  InvalidValueForDigits = "90014",
  InvalidCallControlID = "90015",
  InvalidValueForStop = "90016",
  InvalidValueForClientState = "90017",
  CallHasAlreadyEnded = "90018",
  ConferenceHasAlreadyEnded = "90019",
  CallRecordingTriggeredBeforeAudioStarted = "90020",
  InvalidValueForDuration = "90021",
  InvalidValueForMinimumDigits = "90022",
  InvalidValueForMaximumDigits = "90023",
  InvalidValueForMaximumTries = "90024",
  InvalidValueForTimeoutMillis = "90025",
  InvalidValueForInterDigitTimeoutMillis = "90026",
  InvalidValueForDurationMillis = "90027",
  InvalidValueForTimeoutSecs = "90028",
  InvalidValueForTimeLimitSecs = "90029",
  InvalidValueForServiceLevel = "90030",
  CallIsNotCurrentlyForked = "90031",
  TooManyConferenceParticipants = "90032",
  ConferenceHasNoActiveParticipants = "90033",
  CallHasNotBeenAnsweredYet = "90034",
  CallNotInQueue = "90035",
  QueueFull = "90036",
  QueueMaxSizeCannotBeModified = "90037",
  CallAlreadyInQueue = "90038",
  DownloadingAudioFileFailed = "90040",
  UserTerminationChannelsLimitExceeded = "90041",
  OutboundVoiceProfileChannelsLimitExceeded = "90042",
  ConnectionOutboundChannelsLimitExceeded = "90043",
  ConferenceJoinNotAllowed = "90044",
  MediaStreamingIsUsed = "90045",
  MediaStreamingFailed = "90046",
  MediaStreamingIsNotUsed = "90048",
  InvalidValueForRecordTimeoutSecs = "90049",
  CallRecordingTriggeredWithTimeoutSecsWhileTranscribing = "90053",
  CallTranscriptionIsAlreadyInProgress = "90054",
  CallTranscriptionCannotBeStopped = "90055",
  InvalidValueForInitialTimeoutMillis = "90056",
  InvalidCallControlEventTypeForWebhookURLs = "90057",
  InvalidConferenceID = "90058",
  InvalidValueForRecordingTrack = "90059",
  CannotIssueCommandOnFaxInCurrentState = "90080",
  CannotIssueCommandForInboundFax = "90081",
  NotificationKeyIsInvalid = "90100",
  NotificationContextIsInvalid = "90101",
  CommandIsInvalid = "90102",
  InvalidDialogflowAPI = "100001",
}

export type TelnyxLanguageString =
  | "arb"
  | "cmn-CN"
  | "cy-GB"
  | "da-DK"
  | "de-DE"
  | "en-AU"
  | "en-GB"
  | "en-GB-WLS"
  | "en-IN"
  | "en-US"
  | "es-ES"
  | "es-MX"
  | "es-US"
  | "fr-CA"
  | "fr-FR"
  | "hi-IN"
  | "is-IS"
  | "it-IT"
  | "ja-JP"
  | "ko-KR"
  | "nb-NO"
  | "nl-NL"
  | "pl-PL"
  | "pt-BR"
  | "pt-PT"
  | "ro-RO"
  | "ru-RU"
  | "sv-SE"
  | "tr-TR";

export const TelnyxMessageDirection = {
  INBOUND: "inbound",
  OUTBOUND: "outbound",
} as const;

export type TelnyxMessageDirection =
  (typeof TelnyxMessageDirection)[keyof typeof TelnyxMessageDirection];

export enum TelnyxMessageEventType {
  MESSAGE_RECEIVED = "message.received",
  MESSAGE_SENT = "message.sent",
  MESSAGE_FINALIZED = "message.finalized",
}

export enum TelnyxPortOutEventType {
  PORTOUT_STATUS_CHANGED = "portout.status_changed",
  PORTOUT_NEW_COMMENT = "portout.new_comment",
  PORTOUT_FOC_DATE_CHANGED = "portout.foc_date_changed",
}

export type TelnyxMessageWebhookType =
  | TelnyxMessageEventType.MESSAGE_RECEIVED
  | TelnyxMessageEventType.MESSAGE_SENT
  | TelnyxMessageEventType.MESSAGE_FINALIZED;

export type TelnyxPortOutWebhookType =
  | TelnyxPortOutEventType.PORTOUT_STATUS_CHANGED
  | TelnyxPortOutEventType.PORTOUT_NEW_COMMENT
  | TelnyxPortOutEventType.PORTOUT_FOC_DATE_CHANGED;
